import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Laura Novak - Author", 
  description = "Laura Novak - Award-winning journalist turned novelist. Author of comedic mystery novels set in California, including the Clari Drake mystery series and Downtown LA comedy.",
  keywords = "Laura Novak, author, novelist, mystery novels, California fiction, Clari Drake, Berkeley mysteries, Downtown LA comedy, journalist author, comedic fiction",
  ogImage = "https://customer-assets.emergentagent.com/job_laura-nova-author/artifacts/4aprzk88_DTLAskyline.jpg",
  url = "https://lauranovakwrites.com",
  type = "website",
  author = "Laura Novak",
  schema = null
}) => {
  const fullTitle = title.includes("Laura Novak") ? title : `${title} | Laura Novak`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Laura Novak - Author" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Schema.org structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
